<template>
  <div class="max-resolution">
    <!-- <div class="col-sm-12 custom-display-flex mt-5 mb-5">
      <div class="col-sm-6 text-center">
        <img src="../assets/img/MainPageGraphic.svg" alt />
      </div>
      <div class="col-sm-6 mt-auto mb-auto">
        <div class="col-sm-10 ml-auto">
          <h5
            class="main-page-heading "
          >We can help you in capturing leads and provide excellent customer support on your ecommerce store using Conversational AI,
a seamless communication between humans and machines.</h5>
          <p>Our bots searches across all your data to answers your business queries and to explore data insights, at unprecedented speed and scale.</p>
          <div class="custom-display-flex">
            <button class="darkblue-btn-analytics m-3" @click="route('book_demo')">GET STARTED</button>
            <button class="white-btn-analytics m-3" @click="route('contact_us')">CONTACT US</button>
          </div>
        </div>
      </div>
    </div> -->
    <div class="dont-display-mobile-view">
    <div id="demo" class="carousel slide" data-ride="carousel">
      <!-- Indicators -->
      <ul class="carousel-indicators">
        <li data-target="#demo" data-slide-to="0" class="active"></li>
        <li data-target="#demo" data-slide-to="1"></li>
        <!-- <li data-target="#demo" data-slide-to="2"></li> -->
      </ul>

      <!-- The slideshow -->
      <div class="carousel-inner">
        <div class="carousel-item active pr-4 pl-4">
          <div class="col-sm-12 custom-display-flex mt-5 mb-0">
            <div class="col-sm-5 text-center">
              <img :src="require('../assets/img/Group29.png')" alt />
            </div>
            <div class="col-sm-7 mt-auto mb-auto ml-4">
              <div class="col-sm-11 ml-auto">
                <h2 class="main-page-heading">
                  Cense can help Online Ecommerce Stores Owners in Capturing Leads and Provide Excellent
                  Customer Support on your Ecommerce Store using Conversational
                  AI.
                </h2>
                <p>
                  Cense Conversational Assistant will assist you in capturing leads,
                  product search and comparison for the end user, enticing them
                  for purchase by pushing promotional offers, increase sales by
                  up-selling & cross-selling, integration with popular commerce
                  frameworks like Shopify, WooCommerce, Magento, BIGCOMMERCE,
                  Opencart, PrestaShop and custom made applications.
                  <br />
                  <br />
                  Cense Assistants can also be integrated with messaging services like
                  Telegram, FB Messenger and Instagram to respond to
                  your customer queries when you are busy doing something else.
                </p>
                <div class="custom-display-flex">
                  <button
                    class="darkblue-btn-analytics"
                    style="margin: 1rem 0rem 1rem;"
                    @click="route('register')"
                  >
                    GET STARTED
                  </button>
                  <button
                    class="white-btn-analytics m-3"
                    @click="route('contact_us')"
                  >
                    CONTACT US
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-item pr-4 pl-4">
          <div class="col-sm-12 custom-display-flex mt-5 mb-0 pb-0">
            <div class="col-sm-5 text-center">
              <img :src="require('../assets/img/Group28.png')" alt />
            </div>
            <div class="col-sm-7 mt-auto mb-auto ml-4">
              <div class="col-sm-11 ml-auto">
                <h2 class="main-page-heading">
                  Cense can help Healthcare Service Providers in Reducing No Shows,
                   Improve Revenue Stream, 
                  Productivity of Staff using Conversational AI.
                </h2>
                <p>
                  Cense Conversational Assistant will assist you in capturing leads,
                  easy means of appointment scheduling, re-scheduling &
                  cancellation, and getting referrals at every opportunity.
                </p>
                <div class="custom-display-flex">
                  <button
                    class="darkblue-btn-analytics"
                    style="margin: 1rem 0rem 1rem;"
                    @click="route('register')"
                  >
                    GET STARTED
                  </button>
                  <button
                    class="white-btn-analytics m-3"
                    @click="route('contact_us')"
                  >
                    CONTACT US
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Left and right controls -->
      <!-- <a class="carousel-control-prev" href="#demo" data-slide="prev">
        <span class="carousel-control-prev-icon"></span>
      </a>
      <a class="carousel-control-next" href="#demo" data-slide="next">
        <span class="carousel-control-next-icon"></span>
      </a> -->
      <br />
    </div>
  </div>
    <div class="custom-features-mobile-display" style="width: 100%;">
      <div id="demo" class="carousel slide" data-ride="carousel">
      <!-- Indicators -->
      <ul class="carousel-indicators">
        <li data-target="#demo" data-slide-to="0" class="active"></li>
        <li data-target="#demo" data-slide-to="1"></li>
        <!-- <li data-target="#demo" data-slide-to="2"></li> -->
      </ul>

      <!-- The slideshow -->
      <div class="carousel-inner">
         <div class="carousel-item active">
          <div class="col-sm-12 custom-display-flex mt-5 mb-5">
            <div class="col-sm-5 text-center">
              <img src="../assets/img/Group29.png" alt />
            </div>
            <div class="col-sm-7 mt-auto mb-auto">
              <div class="col-sm-11 ml-auto">
                <h2 class="main-page-heading">
                  Cense can help Online Ecommerce Stores Owners in Capturing Leads 
                  and Provide Excellent Customer Support on your Ecommerce Store 
                  using Conversational AI.
                </h2>
                <p>
                  Cense Conversational Assistant will assist you in capturing leads,
                  product search and comparison for the end user, enticing them
                  for purchase by pushing promotional offers, increase sales by
                  up-selling & cross-selling, integration with popular commerce
                  frameworks like Shopify, WooCommerce, Magento, BIGCOMMERCE,
                  Opencart, PrestaShop and custom made applications.
                  <br />
                  <br />
                  Cense Assistants can also be integrated with messaging services like
                  Telegram, FB Messenger and Instagram to respond to
                  your customer queries when you are busy doing something else.
                </p>
                <div class="custom-display-flex">
                  <button
                    class="darkblue-btn-analytics m-3"
                    @click="route('register')"
                  >
                    GET STARTED
                  </button>
                  <button
                    class="white-btn-analytics m-3"
                    @click="route('contact_us')"
                  >
                    CONTACT US
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-item">
          <div class="col-sm-12 custom-display-flex mt-5 mb-5">
            <div class="col-sm-5 text-center">
              <img src="../assets/img/Group28.png" alt />
            </div>
            <div class="col-sm-7 mt-auto mb-auto">
              <div class="col-sm-11 ml-auto">
                <h2 class="main-page-heading">
                  Cense can help Healthcare Service Providers in Reducing No Shows,
                   Improve Revenue Stream, 
                  Productivity of Staff using Conversational AI.
                </h2>
                <p>
                  Cense Conversational bots will assist you in capturing leads,
                  easy means of appointment scheduling, re-scheduling &
                  cancellation, and getting referrals at every opportunity.
                </p>
                <div class="custom-display-flex">
                  <button
                    class="darkblue-btn-analytics m-3"
                    @click="route('book_demo')"
                  >
                    GET STARTED
                  </button>
                  <button
                    class="white-btn-analytics m-3"
                    @click="route('contact_us')"
                  >
                    CONTACT US
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
       
      </div>

      <!-- Left and right controls -->
      <!-- <a class="carousel-control-prev" href="#demo" data-slide="prev">
        <span class="carousel-control-prev-icon"></span>
      </a>
      <a class="carousel-control-next" href="#demo" data-slide="next">
        <span class="carousel-control-next-icon"></span>
      </a> -->
    </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MainPage",
  methods: {
    route(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>
<style scoped>
@media(max-width:1440px){
.carousel-inner {
  min-height: 610px;
}
}
@media(min-width:2560px){
.carousel-inner {
  min-height: 610px;
}
}
.max-resolution {
  max-width: 1440px; 
  margin: auto !important;
}
</style>